var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80323 6.09634L7.28056 9.409L6.1919 8.01834C5.96523 7.72767 5.54523 7.677 5.2559 7.90434C4.9659 8.131 4.91456 8.55034 5.1419 8.83967L6.76256 10.911C6.88923 11.0723 7.08256 11.1663 7.2879 11.1663H7.29256C7.49856 11.1657 7.69323 11.0683 7.8179 10.9037L10.8639 6.90367C11.0872 6.61034 11.0306 6.193 10.7372 5.96967C10.4432 5.74634 10.0259 5.80367 9.80323 6.09634M8.00016 13.8333C5.0595 13.8333 2.66683 11.4407 2.66683 8.5C2.66683 5.55934 5.0595 3.16667 8.00016 3.16667C10.9408 3.16667 13.3335 5.55934 13.3335 8.5C13.3335 11.4407 10.9408 13.8333 8.00016 13.8333M8.00016 1.83334C4.31816 1.83334 1.3335 4.81867 1.3335 8.5C1.3335 12.1813 4.31816 15.1667 8.00016 15.1667C11.6822 15.1667 14.6668 12.1813 14.6668 8.5C14.6668 4.81867 11.6822 1.83334 8.00016 1.83334",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80323 6.09634L7.28056 9.409L6.1919 8.01834C5.96523 7.72767 5.54523 7.677 5.2559 7.90434C4.9659 8.131 4.91456 8.55034 5.1419 8.83967L6.76256 10.911C6.88923 11.0723 7.08256 11.1663 7.2879 11.1663H7.29256C7.49856 11.1657 7.69323 11.0683 7.8179 10.9037L10.8639 6.90367C11.0872 6.61034 11.0306 6.193 10.7372 5.96967C10.4432 5.74634 10.0259 5.80367 9.80323 6.09634M8.00016 13.8333C5.0595 13.8333 2.66683 11.4407 2.66683 8.5C2.66683 5.55934 5.0595 3.16667 8.00016 3.16667C10.9408 3.16667 13.3335 5.55934 13.3335 8.5C13.3335 11.4407 10.9408 13.8333 8.00016 13.8333M8.00016 1.83334C4.31816 1.83334 1.3335 4.81867 1.3335 8.5C1.3335 12.1813 4.31816 15.1667 8.00016 15.1667C11.6822 15.1667 14.6668 12.1813 14.6668 8.5C14.6668 4.81867 11.6822 1.83334 8.00016 1.83334",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.cdc13b1d5e1b7b7051b6912e6ac12d52.svg";
export { ForwardRef as ReactComponent };